/**
 * Module dependencies.
 */

import {
  Token,
  authorizationHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Options` type.
 */

type Options = {
  favorableId: string;
  token: Token;
};

/**
 * Export `fetchFavoriteExists`.
 */

export async function fetchFavoriteExists({ favorableId, token }: Options) {
  const endpoint = getApiEndpoint('favoriteExists');

  try {
    const { data } = await request.get(endpoint, {
      headers: authorizationHeader(token),
      params: {
        // eslint-disable-next-line id-match
        favorable_id: favorableId
      }
    });

    return data;
  } catch (error) {
    handleRequestError(error);
  }
}
